import { jsx, jsxs } from "react/jsx-runtime";
import * as Config from "@tamagui/config";
import { addTheme, updateTheme } from "@tamagui/theme";
import { useState } from "react";
import {
  Button,
  Square,
  Theme,
  XStack,
  YStack,
  getVariableValue,
  useForceUpdate,
  useIsomorphicLayoutEffect
} from "tamagui";
const colors = Config.config.tokens.color;
const colorKeys = Object.keys(colors);
function UpdateThemeDemo() {
  const [theme, setTheme] = useState();
  const update = useForceUpdate();
  useIsomorphicLayoutEffect(() => {
    addTheme({
      name: "custom",
      insertCSS: true,
      theme: {
        color: "red",
        color2: "blue"
      }
    });
    setTheme("custom");
  }, []);
  return /* @__PURE__ */ jsxs(YStack, { alignItems: "center", space: true, children: [
    /* @__PURE__ */ jsx(XStack, { gap: "$5", children: /* @__PURE__ */ jsx(Theme, { name: theme ?? null, children: /* @__PURE__ */ jsx(Square, { borderRadius: "$8", size: 100, backgroundColor: "$color" }) }) }),
    /* @__PURE__ */ jsx(
      Button,
      {
        onPress: () => {
          const randomColor = getVariableValue(
            colors[colorKeys[Math.floor(Math.random() * colorKeys.length)]]
          );
          updateTheme({
            name: "custom",
            theme: {
              color: randomColor
            }
          });
          update();
        },
        children: "Set to random color"
      }
    )
  ] });
}
export {
  UpdateThemeDemo
};
//# sourceMappingURL=UpdateThemeDemo.js.map
